import styled from "styled-components";
import {media} from "../../../../theme/responsive";
import {
    CharcoalBlack,
    DarkSlate,
    PrimaryOrange,
    Smoke,
    Teal,
    White,
} from "../../../../theme/variable";
import star_icon from "../../../../images/star_icon.svg";
import arrow from "../../../../images/arrow.svg";
import Topper_Sprite from "../../../../images/Topper_Sprite.svg";

export const ReviewContainer = styled.div`
    width: 100%;
    display: table;
    padding: 12px;
    border-bottom: ${(props) => (props.makeVerticalRatingStyle ? "1px solid #ccc" : "")};
    strong {
        font-size: 0.875rem;
        font-weight: 600;
    }
    span {
        font-size: 0.75rem;
    }
    ${media.laptop`padding:${(props) =>
        props.makeVerticalRatingStyle ? "10px" : "16px 92px;"};border-bottom:none;`}
`;
export const ReviewValueContent = styled.div`
    display: block;
    width: 100%;
    text-align: center;
    strong {
        font-weight: 400;
    }
    ${media.laptop`width:${(props) => (props.makeVerticalRatingStyle ? "100%" : "14%")};display:${(
        props,
    ) => (props.makeVerticalRatingStyle ? "flex" : "table-cell")};flex-direction:${(props) =>
        props.makeVerticalRatingStyle ? "column" : ""}`}
`;
export const ReviewValue = styled.div`
    font-size: 3.125rem;
    font-weight: 600;
    line-height: 45px;
    ${media.laptop`margin-top:5px;line-height:inherit;`}
`;
export const ReviewSection = styled.div`
    width: 100%;
    display: block;
    margin-top: 15px;
    ${media.laptop`width:${(props) => (props.makeVerticalRatingStyle ? "100%" : "86%")};display:${(
        props,
    ) => (props.makeVerticalRatingStyle ? "flex" : "table-cell")};margin-top:${(props) =>
        props.makeVerticalRatingStyle ? "30px" : "0"};flex-direction:${(props) =>
        props.makeVerticalRatingStyle ? "column" : ""}`}
`;
export const ReviewSectionContent = styled.div`
    display: table;
    width: 100%;
`;
export const StarReviewSection = styled.div`
    width: 50%;
    display: inline-block;
    text-align: left;
    vertical-align: top;
    &:first-child {
        ${media.laptop`border-right:${(props) =>
            props.makeVerticalRatingStyle ? "none" : "1px solid #e2e2e2"};margin-bottom:${(props) =>
            props.makeVerticalRatingStyle ? "25px" : ""}`}
    }
    &:last-child {
        padding-left: 40px;
        ${media.laptop`padding-left:${(props) =>
            props.makeVerticalRatingStyle ? "0" : "58px"};width:${(props) =>
            props.makeVerticalRatingStyle ? "100%" : "54%"};`}
    }
    ${media.laptop`text-align:center;padding-left:${(props) =>
        props.makeVerticalRatingStyle ? "0" : "35px"};width:${(props) =>
        props.makeVerticalRatingStyle ? "100%" : "46%"};`}
`;
export const ReviewProgress = styled.div`
    display: table-cell;
`;
export const ReviewBar = styled.div`
    display: table;
    width: 100%;
    margin-bottom: 4px;
    strong {
        font-weight: ${(props) => (props.makeVerticalRatingStyle ? "600" : "400")};
        text-align: ${(props) => (props.makeVerticalRatingStyle ? "left" : "")};
        display: inline-block;
        width: 50px;
        font-size: 0.75rem;
        ${media.laptop`width:${(props) => (props.makeVerticalRatingStyle ? "60px" : "70px")};`}
    }
    &.disabled > strong {
        color: #3f3f3f;
        font-weight: 400;
    }
    ${media.laptop`margin-bottom:${(props) => (props.makeVerticalRatingStyle ? "5px" : "2px")};`}
`;
export const ReviewLoadBar = styled.div`
    width: 72px;
    height: ${(props) => (props.makeVerticalRatingStyle ? "12px" : "7px")};
    background: #d8d8d8;
    border-radius: ${(props) => (props.makeVerticalRatingStyle ? "16px" : "4px")};
    display: inline-block;
    ${media.laptop`width:${(props) => (props.makeVerticalRatingStyle ? "140px" : "103px")}`}
`;
export const ReviewFillBar = styled.div`
    background: ${PrimaryOrange};
    height: ${(props) => (props.makeVerticalRatingStyle ? "12px" : "7px")};
    width: ${(props) => props.width}%;
    border-radius: ${(props) => (props.makeVerticalRatingStyle ? "16px 0 0 16px" : "4px 0 0 4px")};
`;
export const ReviewStarProgress = styled.div`
    color: ${CharcoalBlack};
    font-size: 0.75rem;
    width: 36px;
    display: inline-block;
    text-align: left;
    margin-left: 9px;
    ${media.laptop`width:30px;margin-left:15px;`}
`;
export const StarReviewBox = styled.div`
    width: 100%;
    display: table;
    margin-bottom: 4px;
    label {
        font-size: 0.75rem;
        display: block;
        font-weight: 400;
        text-align: left;
        line-height: 16px;
        position: relative;
        ${media.laptop`display:table-cell;width:${(props) =>
            props.makeVerticalRatingStyle ? "120px" : "180px"}`}
    }
    &:last-child {
        margin: 0;
    }
    ${media.laptop`margin-bottom:19px;`}
`;
export const StarReviewList = styled.div`
    display: block;
    text-align: left;
    span {
        display: inline-block;
        width: 25px;
    }
    ${media.laptop`display:table-cell`}
`;
export const RatingBlock = styled.div`
    background: url(${star_icon}) no-repeat;
    background-position: -5px -10px;
    width: 87.8px;
    height: 15px;
    display: inline-block;
    background-size: 100px 59px;
    position: relative;
    top: 2px;
    cursor: default;
    left: 0px;
    ${media.laptop`background-position:${(props) =>
        props.ReviewRatingBlock ? "-6.937px -10px" : " -5.55px -10px"};background-size:${(props) =>
        props.ReviewRatingBlock ? "125px 66px" : "111px 59px"};width:${(props) =>
        props.ReviewRatingBlock ? "109.75px" : "97.458px"};height:${(props) =>
        props.ReviewRatingBlock ? "20px" : "15px"};`}
`;
export const RatingFullBlock = styled.div`
    background: url(${star_icon}) no-repeat;
    background-position: -5px -36px;
    width: ${(props) => props.width}%;
    height: 15px;
    display: inline-block;
    background-size: 100px 59px;
    position: absolute;
    left: 0;
    top: 1px;
    ${media.laptop`background-position: ${(props) =>
        props.ReviewRatingFullBlock ? "-6.937px -36px" : "-5.55px -36px"};background-size: ${(
        props,
    ) => (props.ReviewRatingFullBlock ? "125px 66px" : "111px 59px")};top:${(props) =>
        props.ReviewRatingFullBlock ? "-5px" : "-1px"};height:${(props) =>
        props.ReviewRatingFullBlock ? "20px" : "15px"};`}
`;
export const ReviewCTASection = styled.div`
    width: 100%;
    display: table;
    padding: 0 0px 12px;
    ${media.laptop`padding:16px;border-top:1px solid ${Smoke};`}
`;
export const ReviewCTABox = styled.div`
    width: 100%;
    display: block;
    text-align: left;
    vertical-align: middle;
    &:first-child {
        border-bottom: 1px solid ${Smoke};
        padding: 0 10px 10px 10px;
        margin-bottom: 12px;
        ${media.laptop`border:none;padding:0;margin:0;`}
    }
    button {
        display: block;
        margin: 0 auto;
        &:first-child {
            margin-bottom: 12px;
            border: 1px solid ${Teal};
            ${media.laptop`margin-right:16px;margin-bottom:0;border: 1px solid ${Teal};`};
        }
        ${media.laptop`display:inline-block;`}
    }
    p {
        text-align: left;
        font-size: 0.75rem;
        line-height: 17px;
        display: inline-block;
        width: 90%;
        strong {
            font-weight: 400;
        }
    }
    &:last-child {
        text-align: center;
        ${media.laptop`width:50%;text-align:right;`}
    }
    ${media.laptop`width:47%;margin:0;display:table-cell;`}
`;

export const ReviewSortSection = styled.div`
    width: 100%;
    display: table;
    border-top: ${(props) => (props.sortTypeBadge ? "1px solid #e5f1ff" : `1px solid ${Smoke};`)};
    padding: ${(props) => (props.sortTypeBadge ? "16px" : "")};
    label {
        border-right: ${(props) => (props.sortTypeBadge ? "" : `1px solid ${Smoke};`)};
        display: ${(props) => (props.sortTypeBadge ? "block" : "table-cell")};
        width: ${(props) => (props.sortTypeBadge ? "100px" : "72px")};
        text-align: ${(props) => (props.sortTypeBadge ? "left" : "center")};
        font-size: 0.875rem;
        vertical-align: middle;
        font-weight: ${(props) => (props.sortTypeBadge ? "600" : "400")};
        margin-bottom: ${(props) => (props.sortTypeBadge ? "10px" : "")};
        ${media.laptop`
            width:100px;
            margin-right:${(props) => (props.sortTypeBadge ? "10px" : "")};
            display:table-cell;
            text-align:center;
            margin-bottom:${(props) => (props.sortTypeBadge ? "unset" : "")};
        `}
        &:before {
            content: ${(props) => (props.sortTypeBadge ? "''" : "")};
            display: inline-block;
            vertical-align: middle;
            background: url(${Topper_Sprite}) no-repeat;
            width: 22px;
            height: 22px;
            background-position: -137px -168px;
            margin-right: 4px;
        }
    }
`;
export const ReviewSortLabel = styled.div`
    display: ${(props) => (props.sortTypeBadge ? "inline-block" : "table-cell")};
    width: ${(props) => (props.sortTypeBadge ? "auto" : "")};
    padding: ${(props) => (props.sortTypeBadge ? "6px 10px" : "6px 16px 6px 8px;")};
    font-size: 0.875rem;
    position: relative;
    cursor: pointer;
    border-right: ${(props) => (props.sortTypeBadge ? "" : `1px solid ${Smoke}`)};
    text-align: center;
    vertical-align: middle;
    border-radius: ${(props) => (props.sortTypeBadge ? "80px" : "")};
    background: ${(props) => (props.sortTypeBadge ? "#F7F7F7" : "")};
    margin-right: ${(props) => (props.sortTypeBadge ? "12px" : "")};
    &:last-child {
        border: none;
        margin-right: ${(props) => (props.sortTypeBadge ? "0" : "")};
    }
    &:hover {
        background: ${(props) => (props.sortTypeBadge ? "#2E6E74" : "")};
        color: ${(props) => (props.sortTypeBadge ? `${White}` : "")};
    }
    span {
        position: relative;
        &:after {
            content: ${(props) => (props.sortTypeBadge ? "" : "''")};
            background: url(${arrow}) no-repeat;
            width: 10px;
            height: 15px;
            position: absolute;
            right: -21px;
            top: 33%;
            display: none;
            ${media.laptop`right: -16px; top: 3px;`}
        }
    }
    &.arrowPos span:after {
        right: -13px;
        top: 25%;
        ${media.laptop`right: -16px; top: 3px;`}
    }
    &.active {
        background: ${(props) => (props.sortTypeBadge ? "#2E6E74" : `${Teal}`)};
        color: ${White};
        font-weight: 600;
    }
    &.active > span:after {
        display: inline-block;
    }
    ${media.laptop`
    padding:12px 16px;
    width: ${(props) => (props.sortTypeBadge ? "133px" : "")};
    `}
`;
export const ReviewCardContainer = styled.div`
    width: 100%;
    border-bottom: ${(props) => (props.makeApplyCardStyle ? `1px solid ${Smoke}` : "none")};
`;
export const ReviewProfile = styled.div`
    width: 100%;
    display: table;
    padding: ${(props) => (props.makeApplyCardStyle ? "12px 12px 0 12px" : `12px`)};
    border-bottom: ${(props) => (props.makeApplyCardStyle ? "none" : `1px solid ${Smoke}`)};
    ${media.laptop`padding:${(props) => (props.makeApplyCardStyle ? "10px 16px 0" : `10px 16px`)};`}
`;
export const ReviewProfileSection = styled.div`
    display: table-cell;
    &:first-child {
        width: 100%;
        ${media.laptop`width:${(props) => (props.makeApplyCardStyle ? "83%" : "85%")}`};
    }
    &:last-child {
        display: none;
        ${media.laptop`width:17%;vertical-align:top;display:table-cell;`}
    }
    span.reviewTag {
        font-size: 0.75rem;
        color: ${DarkSlate};
    }
    ${media.laptop`text-align:right;`}
`;
export const ReviewUserImage = styled.div`
    display: table-cell;
    vertical-align: middle;
    cursor: ${(props) => (props.userProfileUrl ? "pointer" : "default")};
    div {
        width: ${(props) => (props.makeApplyCardStyle ? "42px" : "62px")};
        height: ${(props) => (props.makeApplyCardStyle ? "42px" : "62px")};
        border-radius: 50%;
        border: 1px solid ${Smoke};
        ${media.laptop` width:62px;height:62px;`}
    }
    img {
        border-radius: 50%;
    }
`;
export const ReviewUserDetails = styled.div`
    padding-left: ${(props) => (props.makeApplyCardStyle ? "11px" : "16px")};
    display: table-cell;
    vertical-align: middle;
    font-size: 0.75rem;
    text-align: left;
    p {
        font-size: 0.75rem;
        strong {
            font-weight: 400;
        }
        ${media.laptop`display:inline-block;
        margin-right:4px;`}
    }
`;
export const ReviewUserName = styled.div`
    font-size: 0.75rem;
    margin-bottom: 2px;
    cursor: ${(props) => (props.userProfileUrl ? "pointer" : "default")};
    strong {
        display: inline-block;
        font-size: 1rem;
        font-weight: 600;
        color: ${Teal};
    }
`;
export const ReviewContent = styled.div`
    font-size: 0.875rem;
    line-height: 21px;
    padding: ${(props) => (props.makeApplyCardStyle ? "0px 12px 12px 65px" : "12px")};
    p {
        word-break: break-word;
    }
    strong {
        font-weight: 600;
    }
    ${media.laptop`padding:${(props) =>
        props.makeApplyCardStyle ? "0 16px 16px 90px" : "16px"};`};
`;
export const ReviewTag = styled.div`
    font-size: 0.75rem;
    color: ${DarkSlate};
    margin-top: 5px;
    ${media.laptop`display:none;`}
`;
export const RateScore = styled.span`
    display: inline-block;
    background: ${Teal};
    color: ${White};
    font-size: 0.875rem;
    line-height: 21px;
    padding: 0px 4px;
    text-align: center;
    border-radius: 2px;
    font-weight: 400;
    margin-right: 5px;
`;
export const TickMark = styled.span`
    display: inline-block;
    width: 20px;
    height: 16px;
    transform: rotate(45deg);
    position: relative;
    top: -15px;
    ${media.laptop``}
`;
export const TickMarkStem = styled.span`
    position: absolute;
    width: 2px;
    height: 12px;
    background-color: ${Teal};
    left: 11px;
    top: 6px;
`;
export const TickMarkKick = styled.span`
    position: absolute;
    width: 7px;
    height: 2px;
    background-color: ${Teal};
    left: 6px;
    top: 16px;
`;
export const ToolTipWrapper = styled.div`
    position: relative;
    display: inline-block;
    span.infoIcon {
        font-size: 13px;
        cursor: pointer;
        position: relative;
        top: 2px;
        right: -4px;
        &:hover + div {
            opacity: 1;
        }
    }
`;
export const Tooltip = styled.div`
    background: ${DarkSlate};
    color: ${White};
    max-width: 250px;
    border-radius: 2px;
    width: 240px;
    top: 147%;
    text-align: center;
    margin-top: 1px;
    line-height: 16px;
    font-size: 0.75rem;
    opacity: 0;
    transform: 15px 0;
    transition: 0.2s ease all;
    transform-origin: 15px 0;
    left: auto;
    right: -10px;
    position: absolute;
    z-index: 1;
    pointer-events: none;
    ${media.laptop`right: ${(props) => (props.makeVerticalRatingStyle ? "-125px" : "-10px")};`};
`;
export const TooltipIcon = styled.span`
    position: absolute;
    right: 19px;
    &:before {
        content: "";
        border: solid transparent;
        position: absolute;
        top: -10px;
        left: 0px;
        border-width: 6px;
        border-bottom-color: #666;
        margin: -2px 0 0 -1px;
    }
    ${media.laptop`right:${(props) => (props.makeVerticalRatingStyle ? "56%" : " 19px")};`};
`;
export const TooltipText = styled.span`
    padding: 4px 8px;
    display: block;
`;
export const ApplyRatingBlock = styled.div`
    width: 100%;
    text-align: center;
    margin: 2px 0 5px;
    ${media.laptop`margin:5px 0;`};
`;
